'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';

export default function GoogleAnalytics() {
  const [isProd, setIsProd] = useState(false);

  useEffect(() => {
    try {
      const portalUrl = process.env.NEXT_PUBLIC_GUEST_PORTAL_URL;
      if (portalUrl) {
        const prodHostname = new URL(portalUrl).hostname;
        const baseHostname = prodHostname.replace(/^www\./, '');
        
        if (
          window.location.hostname === prodHostname ||
          window.location.hostname === baseHostname
        ) {
          setIsProd(true);
        }
      }
    } catch (error) {
      console.error('Error parsing NEXT_PUBLIC_GUEST_PORTAL_URL:', error);
    }
  }, []);

  if (!isProd) return null;

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-VTQ55LDB42"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-VTQ55LDB42');
        `}
      </Script>
    </>
  );
}
